import { createLayer } from "@/api/hooks/layer";
import { withCustomBackgroundMapColorDefaults } from "@/constants/backgroundMapCustomStyle";
import { useProfileAndTabParams } from "@/hooks";
import type { LayerCreateControllerProp } from "@/overlay/components/SmartForm/LayerForms/LayerFormMapping";
import { useAppDispatch } from "@/reducer";
import type { BackgroundMapLayerCreate } from "@mm/metx-workbench.meteomatics.com";
import _ from "lodash";
import type { SubmitHandler } from "react-hook-form";
import {
  CartographicMaterialCreateForm,
  type CartographicMaterialFormData,
} from "../view/CartographicMaterialCreateForm";

export function buildBackgroundMapCreatePayload(
  defaultPayload: BackgroundMapLayerCreate,
  layerDataPatch: Partial<CartographicMaterialFormData["layerData"]>,
): BackgroundMapLayerCreate {
  const mergedPayload = _.merge({}, defaultPayload, layerDataPatch);

  return {
    ...mergedPayload,
    custom_options: withCustomBackgroundMapColorDefaults(mergedPayload.style, mergedPayload.custom_options),
  };
}

/**
 * Handles all the logic for map background layer implementation creation.
 * Note:
 * This is a controller, meaning that we should generally NOT delegate layer creation logic
 * to the parent component by passing callback from parent etc.
 */
export function CartographicMaterialCreateController(props: LayerCreateControllerProp<BackgroundMapLayerCreate>) {
  const { selectedMapId, defaultPayload, onDone } = props;
  const dispatch = useAppDispatch();
  const { profileId } = useProfileAndTabParams();

  const onSubmit: SubmitHandler<CartographicMaterialFormData> = (formData) => {
    if (!profileId) {
      return;
    }
    const finalPayload = buildBackgroundMapCreatePayload(defaultPayload, formData.layerData);
    dispatch(createLayer({ mapId: selectedMapId, profileId: profileId, data: finalPayload }));

    onDone?.();
  };

  return (
    <>
      <CartographicMaterialCreateForm
        defaultFormData={defaultPayload}
        onSubmit={onSubmit}
        submitMode="onSubmit"
        onCancel={props.onDone}
      />
    </>
  );
}
